/*
 * @Author: your name
 * @Date: 2020-02-20 10:44:08
 * @LastEditTime: 2020-02-25 15:41:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \handlephoto\src\utils\cookie.js
 */
export const setCookie = (name, value, days) => {
  var exp = new Date();
  exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie =
    name + "=" + escape(value) + "; expires=" + exp.toUTCString() + "; path=/" + ";";
};

export const getCookie = name => {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (document.cookie.match(reg)) {
    arr = document.cookie.match(reg);
    return unescape(arr[2]);
  } else return null;
};

export const delCookie = name => {
  setCookie(name, "", -1);
};
